module.exports = __webpack_public_path__ + "img/people-47-min.f321f6a9.png";